import type { AppointmentType } from '@bb/domain/dist/types';

export const zPositions = {
  universalSearch: 1060,
  tourModal: 2000,
  calendarSyncModal: 2005,
  tourModalComponents: 2010,
  tourModalSubModal: 2020,
  inviteBuyer: 2050,
  contactModal: 2100,
  contactModalComponents: 2150,
  drawer: 2000,
};

export const GOOGLE_MAP_PLACEHOLDER_COORDS = [43.653, -79.383];

/** Showing types that accept feedback */
export const FEEDBACK_TYPES: (
  | AppointmentType
  | 'APPOINTMENT'
  | 'ROUTE_STOP'
)[] = ['Buyer/Broker', 'Revisit', 'Dual Agency', 'Agent Inspection'];
